module.exports = __webpack_public_path__ + "img/glow-green-l.2ac5f684.png";